import React from 'react';
import BenefitCard from './benefitCard';
import PropTypes from 'prop-types';
const BenefitsList = ({ data, fullWidth, displayOnMobile, displayDesktop, displayTablet }) => {
	const textColor = data?.checkout_v3_benefits_textColor;
	return (
		<div
			className={`benefitsContainer ${fullWidth == 'full' ? 'benefitsContainer--fullWidth' : 'benefitsContainer'} ${
				displayOnMobile ? 'benefitsContainer--mobile' : 'benefitsContainer--desktop'
			}
				${displayDesktop ? 'benefitsContainer--onlyDesktop' : ''}
				${displayTablet ? 'benefitsContainer--tablet' : ''}
			`}
		>
			<div className="benefitsContainer__wrapper">
				{data?.checkout_v3_benefits_repeater &&
					data?.checkout_v3_benefits_repeater.map((benefit, index) => {
						return (
							<BenefitCard
								color={textColor}
								key={index}
								type={fullWidth}
								icon={benefit.tr_checkout_v3_benefits_repeater_icon}
								text={benefit.tr_checkout_v3_benefits_repeater_text}
								offset={benefit.checkout_v3_benefits_repeater_offset}
							/>
						);
					})}
			</div>
		</div>
	);
};

BenefitsList.propTypes = {
	fullWidth: PropTypes.string,
};

export default BenefitsList;
